module.exports = __webpack_public_path__ + "static/media/hotel-guide.6cb3a6ad.png";